import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const parseQueryParams = (value, defaultValue) => {
	const parsedValue = Number.parseInt(value);
	return Number.isNaN(parsedValue) ? defaultValue : parsedValue;
};

export function usePagination(
	defaultPageSize = 25,
	defaultPage = 1,
	defaultPageSizes = [25, 50, 100]
) {
	const [searchParams, setSearchParams] = useSearchParams();

	const pageSize = parseQueryParams(
		searchParams.get('pageSize'),
		defaultPageSize
	);

	const page = parseQueryParams(searchParams.get('page'), defaultPage);

	useEffect(() => {
		if (!defaultPageSizes.includes(pageSize)) {
			setSearchParams({ pageSize: defaultPageSize, page });
		}
	}, [defaultPageSize, defaultPageSizes, page, pageSize, setSearchParams]);

	const paginationModel = useMemo(
		() => ({
			pageSize,
			page: page - 1,
		}),
		[pageSize, page]
	);

	const handlePaginationChange = useCallback(
		({ page, pageSize }) => {
			setSearchParams({ pageSize, page: page + 1 });
		},
		[setSearchParams]
	);

	return {
		paginationModel,
		handlePaginationChange,
	};
}
